export default __webpack_public_path__ + "static/media/favicon-192x192.2b48705e.png";